/**
 * Bloque de acción de una respuesta (GEN-EKB-027, mockup A-despacho-conversacion): Jimmy confirma el KB de destino con
 * botones dentro de la conversación. El kernel no emite un evento aparte: el bloque viaja en el propio texto,
 *
 *   :::accion
 *   Confirmar el KB de destino
 *   - Sí, en Proveedores
 *   - Mejor en Personas
 *   :::
 *
 * y el Pórtico lo separa del texto y lo pinta. Pulsar una opción envía esa opción como mensaje de la persona.
 *
 * GEN-EKB-035: el bloque admite, sin romper el anterior, una línea `tipo: Propuesta de iKu` (la etiqueta pequeña de arriba, en vez de «Confirmar»)
 * y líneas de detalle tras el título (resumen, KB, texto), que se pintan como párrafos:
 *
 *   :::accion
 *   tipo: Propuesta de iKu
 *   Plazo de pago a proveedores
 *   Resumen: Se paga a 60 días.
 *   KB: Proveedores
 *   - Confirmar
 *   - Cambiar KB
 *   - Descartar
 *   :::
 * Mientras la respuesta llega por trozos el bloque aún no está cerrado: no se pinta hasta que lo está.
 */
const RE_BLOQUE = /^:::accion[ \t]*\n([\s\S]*?)\n:::[ \t]*$/m

const RE_TIPO = /^tipo:\s*(.+)$/i

/** { texto, accion } — `accion` es { titulo, opciones[], tipo?, detalle? } (tipo y detalle solo si el bloque los trae) o null si no hay un bloque completo con al menos una opción. */
export function separarAccion(markdown) {
  const m = RE_BLOQUE.exec(markdown ?? '')
  if (!m) return { texto: markdown ?? '', accion: null }
  const lineas = m[1].split('\n').map(l => l.trim()).filter(Boolean)
  const opciones = lineas.filter(l => /^[-*] /.test(l)).map(l => l.slice(2).trim()).filter(Boolean)
  const sueltas = lineas.filter(l => !/^[-*] /.test(l))
  const tipo = sueltas.map(l => RE_TIPO.exec(l)?.[1].trim()).find(Boolean)
  const cuerpo = sueltas.filter(l => !RE_TIPO.test(l))
  const titulo = cuerpo[0] ?? 'Confirmar'
  const detalle = cuerpo.slice(1)
  const texto = (markdown.slice(0, m.index) + markdown.slice(m.index + m[0].length)).trim()
  return opciones.length
    ? { texto, accion: { titulo, opciones, ...(tipo ? { tipo } : {}), ...(detalle.length ? { detalle } : {}) } }
    : { texto: markdown, accion: null }
}
